/*
Copyright (C) 2017  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React from "react";
import styled from "styled-components";
// import { ThemePalette } from "@src/components/Theme"; -- the label is slate-700 now, which the palette has no key for

import TextInput from "@src/components/ui/TextInput";

const Wrapper = styled.div<any>`
  width: 100%;
`;
// 14px medium slate-700 labels over 38px fields, as signin.tech9iq.com's form (was 13px semibold over 40px).
const FormFieldLabel = styled.label<any>`
  display: block;
  color: var(--t9-text-body);
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
const StyledTextInput = styled(TextInput)<any>`
  width: 100%;
  box-sizing: border-box;
  height: 38px;
  border-radius: 8px;
`;

type Props = {
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  name?: string;
  type?: string;
};
const LoginFormField = (props: Props) => (
  <Wrapper>
    <FormFieldLabel>{props.label}</FormFieldLabel>
    <StyledTextInput {...props} onChange={props.onChange} />
  </Wrapper>
);

export default LoginFormField;
